import { useEffect } from 'react';

const GtmTag = ({ id }) => {
  useEffect(() => {
    const src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

    const ensureGtagInitialized = () => {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      if (!window.gtag) {
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
      }

      window.gtag('js', new Date());
      window.gtag('config', id);
    };

    const existing = document.querySelector(`script[src="${src}"]`);
    let addedScript = false;

    if (existing) {
      ensureGtagInitialized();
    } else {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      script.onload = ensureGtagInitialized;
      document.head.appendChild(script);
      addedScript = true;
    }

    return () => {
      if (addedScript) {
        const node = document.querySelector(`script[src="${src}"]`);
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      }
    };
  }, [id]);

  return null;
};

export default GtmTag;
